export const paragraph = {
  primaryNumber: {
    color: "primary",
    fontSize: 5,
    fontWeight: "bold",
  },
};
